import * as React from 'react';
import { gray } from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';
import { IMobileWaypoint } from '../../../interfaces';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        borderBottom: `1px solid ${gray}`,
        paddingBottom: 10,
        fontSize: 15,
    },
    img: {
        display: 'flex',
        float: 'right',
        margin: '10px 0px 10px 10px',
    },
    time: {
        fontWeight: 'bold',
        marginTop: 10,
    },
    atTime: {
        marginRight: 10,
    },
    spacer: {
        clear: 'both',
    },
};

export function WaypointRowBody(props: IMobileWaypoint) {
    const { arrival, departure, image, description } = props;
    return (
        <div>
            <div style={styles.wrapper}>
                <div style={styles.time}>
                    {arrival && (
                        <span style={styles.atTime}>{`${__('at', 'dreamlines')} ${arrival}`}</span>
                    )}
                    {departure && <span>{`${__('off', 'dreamlines')} ${departure}`}</span>}
                </div>
                <img style={styles.img} src={image} />
                <div dangerouslySetInnerHTML={{ __html: description }} />
                <div style={styles.spacer}></div>
            </div>
        </div>
    );
}
